<template lang="pug" src="./footer.pug"></template>

<script>
import Icon from 'components/icon/icon'

import { openModal } from '@/methods'

export default {
  data () {
    return {
      orthodontic: true,
      styleWidth: '',
      styleHeight: '',
      styleTop: '',
      styleLeft: '',
      dropdownActive: false,
      active: 1
    }
  },
  computed: {
    props () {
      return this.$store.state.app.global
    },
    links () {
      return this.$router.options.routes
    },
    dropdownBackgroundStyleObject () {
      return {
        height: this.styleHeight,
        width: this.styleWidth,
        top: this.styleTop,
        left: this.styleLeft
      }
    }
  },
  mounted () {
    this.toggleWords()
  },
  mixins: [openModal],
  components: {
    Icon
  },
  methods: {
    toggleWords () {
      // this.orthodontic = !this.orthodontic
      // setTimeout(() => { this.toggleWords() }, 2500)
    },
    // handleRoute (link) {
    //   this.$router.push(link.path)
    // },
    handleEnter (e, i) {
      this.dropdownActive = true
      this.active = i

      const navCoords = e.target.parentElement.getBoundingClientRect()

      setTimeout(() => {
        const coords = e.target.children[0].getBoundingClientRect()
        this.styleWidth = coords.width + 'px'
        this.styleHeight = coords.height + 'px'
        this.styleTop = coords.top - navCoords.top + 'px'
        this.styleLeft = coords.left - navCoords.left + 'px'
      }, 100)
    },
    handleLeave () {
      this.dropdownActive = false
      this.active = false
      // this.styleWidth = ''
      // this.styleHeight = ''
      // this.styleTop = ''
      // this.styleLeft = ''
    },
    handleRoute (e) {
      this.$router.push(e.path)
      this.handleLeave()
    },
    goToConsultation () {
      this.$router.push('/free-orthodontic-consultation')
    },
    goToPediatric () {
      this.$router.push('/pediatric-appointment')
    },
    showingBanner () {
      const routesWithoutBanner = [
        'free-orthodontic-consultation',
        'pediatric-appointment',
        'thank-you-appointment',
        'thank-you-consultation',
        'virtual-orthodontic-consultation',
        'thank-you-virtual'
      ]
      return !routesWithoutBanner.some(routeString => this.$route.path.includes(routeString))
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?2771f9fe